import { PermissionType } from "amnShared/Permissions/IPermissions";

interface RoutePermissionMap {
  [path: string]: PermissionType;
}

export const RoutePermissions: RoutePermissionMap = {
  // Restaurant Routes
  "/restaurants/OrderManagement": PermissionType.CanUseOrderManagementTab,
  "/restaurants/driverManagementPage":
    PermissionType.CanUseDeliveryOrdersManagement,
  "/restaurants/deliveryTripSettlementPage/:id":
    PermissionType.CanSettleDeliveryTrip,
  "/restaurants/shiftSummary/:id": PermissionType.CanViewShiftDigest,
  "/restaurants/calculatedCashDetails/:id":
    PermissionType.CanViewCalculatedCashDetails,
  "/restaurants/materialsTransactionDetails/:id":
    PermissionType.CanViewMaterialsAndServicesTransactionsDetail,
  "/restaurants/externalTransactionDetails/:id":
    PermissionType.CanViewExternalTransactionsDetails,
  "/restaurants/shiftClosingDetails/:id": PermissionType.CanViewClosingDetails,
  "/restaurants/materialsTransactions/finished":
    PermissionType.ViewSettledTransactions,
  "/restaurants/restDeliverPickUpOrderPage/:id":
    PermissionType.CanSettlePickupOrder,
  "/restaurants/customer-statement-report/:id":
    PermissionType.CanViewCustomerBalanceStatement,
  "/restaurants/create-client": PermissionType.CanAddNewClient,
  "/restaurants/edit-client/:id": PermissionType.CanModifyExistingClient,
  // POS Routes
  "/pos/shiftSummary/:id": PermissionType.CanViewShiftDigest,
  "/pos/calculatedCashDetails/:id": PermissionType.CanViewCalculatedCashDetails,
  "/pos/materialsTransactionDetails/:id":
    PermissionType.CanViewMaterialsAndServicesTransactionsDetail,
  "/pos/externalTransactionDetails/:id":
    PermissionType.CanViewExternalTransactionsDetails,
  "/pos/shiftClosingDetails/:id": PermissionType.CanViewClosingDetails,
  "/pos/customer-statement-report/:id":
    PermissionType.CanViewCustomerBalanceStatement,
  "/pos/OrderManagement": PermissionType.CanUseOrderManagementTab,
  "/pos/deliveryTripSettlementPage/:id": PermissionType.CanSettleDeliveryTrip,
  "/pos/deliverPickUpOrderPage/:id": PermissionType.CanSettlePickupOrder,
  "/pos/create-client": PermissionType.CanAddNewClient,
  "/pos/edit-client/:id": PermissionType.CanModifyExistingClient,
  "/pos/materialsTransactions/finished": PermissionType.ViewSettledTransactions,
  "/pos/driverManagementPage": PermissionType.CanUseDeliveryOrdersManagement,
};
